
<div class="row justify-content-center">
  <div class="col-lg-8 content-area">
   
    <div class="page-card" id="copyright">
      <div>
        <h2 class="f-s-20 f-w-700 m-t-24 page-title" [class.active-heading]="selectedSection === 'copyright'">Copyright</h2>

        <p class="f-s-14">
          The software, documentations, images, icons, text or any other information contained in the software, user’s guide, brochures and other documentations are protected under the copyright laws and may not be copied, photocopied, reproduced, translated or converted in whole or in part to any electronic medium, machine-readable form or any other format without the prior written consent of Andica Limited. Such written consent must be specific and not implied.
        </p>

        <p class="f-s-14">
          Note: This guide covers Andica® Charity Accounts software developed by Andica Limited. Taxation and other rates and any calculations displayed in the user guide are for display purposes only.
        </p>

        <p class="f-s-14">
          This guide is by no means a substitute to training and knowledge of the tax return functions and it does not cover all the features of Andica Software. Tax return routines may vary from one return to another. It is strongly recommended that you obtain training on use of the software to suit your requirements. Support is not included in the price of the software and the company reserves the right to provide (and/or refuse) support for the product. Customers can separately purchase technical support
        </p>

        <p class="f-s-14">
          All Andica Charity Accounts software screenshots are for illustration only, the software may differ from these images displayed.
        </p>

        <p class="f-s-14">
          <strong>Andica Limited © 2003-2026. All rights reserved.</strong> Andica, Andica Software, Andica logo with or without the words Andica Limited, Andica Charity Accounts software, Andica with a product descriptive name, are trademarks or registered trademarks of Andica Limited in the European Community and/or other countries. Microsoft and Windows are registered trademarks and/or trademarks of Microsoft Corporation. InstallShield is a registered trademark of InstallShield Software Corporation. All other company names or product names may be trademarks of their respective owners. All parties’ registered trademarks or service marks are the property of their respective owners and should be treated as such.
        </p>

        <p class="f-s-14">
          This program is protected by International copyright laws.
        </p>
      </div>

      <div id="developers" class="info-box">

        <p class="f-s-14 m-t-24" [class.active-heading]="selectedSection === 'developers'">Developers</p>
        <strong class="f-s-14">Andica Limited</strong>
        <p class="f-s-14">The Pines</p>
        <p class="f-s-14">Daws Hill Lane</p>
        <p class="f-s-14">High Wycombe</p>
        <p class="f-s-14">Buckinghamshire</p>
        <p class="f-s-14">HP11 1PW</p>

        <p class="f-s-14">Tel: 01494 360 960</p>

        <p class="f-s-14"><a style="color:blue" href="https://andica.com/" target="_blank">www.andica.com</a></p>
        <p class="f-s-14"><a style="color:blue" href="mailto:info@andica.com"> info&#64;andica.com </a> </p>
      </div>
    </div>
  </div>

    <!-- Right Sidebar -->
    <div class="col-lg-3">
      <div class="on-page-sidebar">
        <p class="sidebar-title">On this page</p>

        <ul class="scroll-container">
          <li [class.active]="selectedSection === 'copyright'"
            (click)="changeSection('copyright')">
          <a>Copyright</a>
        </li>
        <!--<li [class.active]="selectedSection === 'developers'"
            (click)="changeSection('developers')">
          <a>Developers</a>
        </li>-->
        </ul>
      </div>
    </div>

  </div>
